export const MenuToggleIcon = ({ isPinned }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
    <defs>
      <filter id="Ellipse_5" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse">
        <feOffset input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="blur" />
        <feFlood floodOpacity="0.161" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Ellipse_5)">
      <circle
        cx="18"
        cy="18"
        r="18"
        transform="translate(9 9)"
        fill={isPinned ? '#0F7F85' : '#fff'}
        style={{ transition: 'fill 0.4s' }}
      />
    </g>
    {/* 사이드바 패널 */}
    <rect
      x="17"
      y="17"
      width="20"
      height="20"
      rx="3"
      fill="none"
      stroke={isPinned ? '#fff' : '#555'}
      strokeWidth="1.8"
      style={{ transition: 'stroke 0.4s' }}
    />
    {/* 사이드바 왼쪽 영역 구분선 */}
    <line
      x1="24"
      y1="17"
      x2="24"
      y2="37"
      stroke={isPinned ? '#fff' : '#555'}
      strokeWidth="1.8"
      style={{ transition: 'stroke 0.4s' }}
    />
    {isPinned ? (
      /* 고정 상태: 핀 아이콘 (사이드바 오른쪽 영역에) */
      <g transform="translate(28.5, 23)" style={{ transition: 'all 0.4s' }}>
        <circle cx="2.5" cy="2" r="2" fill="none" stroke="#fff" strokeWidth="1.5" />
        <line x1="2.5" y1="4" x2="2.5" y2="8" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
      </g>
    ) : (
      /* 해제 상태: 왼쪽 화살표 (사이드바 오른쪽 영역에) */
      <g transform="translate(28, 27)" style={{ transition: 'all 0.4s' }}>
        <polyline
          points="5,0 1,0"
          fill="none"
          stroke="#555"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <polyline
          points="2.5,-2.5 0,0 2.5,2.5"
          fill="none"
          stroke="#555"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    )}
  </svg>
);
